<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="text-h6 font-weight-bold d-inline">
          Documentos de Personal SSC
        </div>
      </v-col>
      <template v-if="documentosPersonal.length > 0">
        <v-col
          v-for="(documento, index) in documentosPersonal"
          :key="index"
          cols="3"
        >
          <v-card
            color="secondary"
            tile
          >
            <v-card-title class="d-inline-block">
              <div class="text-subtitle-1 font-weight-bold white--text">
                {{ documento.nombre }}
              </div>
              <div class="text-subtitle-2 font-weight-bold white--text">
                {{ documento.TipoDocumento.title }}
              </div>
              <div class="text-body-2 primary--text">
                Archivo cargado el {{ formatDate(documento.fecha) }}
              </div>
            </v-card-title>
            <v-card-text>
              <div class="text-caption primary--text">
                Observaciones
              </div>
              <div
                v-if="documento.observaciones !== ''"
                class="text-body-2 primary--text font-weight-bold"
              >
                {{ documento.observaciones }}
              </div>
              <div
                v-else
                class="text-body-2 primary--text font-weight-bold"
              >
                No hay observaciones
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                icon
                color="white"
                @click="openEliminaDocumentoDialog(documento.iddocumentosPersonal)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <v-btn
                icon
                color="white"
                class="mr-4"
                @click="download(documento.URL)"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </template>
      <v-col
        cols="12"
        align="center"
      >
        <div class="text-subtitle-1 font-weight-bold text--disabled">
          No hay documentos registrados.
        </div>
      </v-col>
    </v-row>
    <v-divider class="my-4" />
    <v-row>
      <v-col cols="12">
        <div class="text-h6 font-weight-bold d-inline">
          Documentos de Confiabilidad
        </div>
      </v-col>
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-bold d-inline">
          Documentos generales
        </div>
        <agregar-documento-dialog-component :id-personal="personal.idPersonal" />
      </v-col>
    </v-row>
    <v-row v-if="filteredDocumentos.length > 0">
      <v-col
        v-for="documento in filteredDocumentos"
        :key="documento.id"
        cols="3"
      >
        <v-card
          color="secondary"
          tile
        >
          <v-card-title class="d-inline-block">
            <div class="text-subtitle-1 font-weight-bold white--text">
              {{ documento.nombre }}
            </div>
            <div class="text-subtitle-2 font-weight-bold white--text">
              {{ documento.TipoDocumento.title }}
            </div>
            <div class="text-body-2 primary--text">
              Archivo cargado el {{ formatDate(documento.fecha) }}
            </div>
          </v-card-title>
          <v-card-text>
            <div class="text-caption primary--text">
              Observaciones
            </div>
            <div
              v-if="documento.observaciones !== ''"
              class="text-body-2 primary--text font-weight-bold"
            >
              {{ documento.observaciones }}
            </div>
            <div
              v-else
              class="text-body-2 primary--text font-weight-bold"
            >
              No hay observaciones
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              icon
              color="white"
              @click="openEliminaDocumentoDialog(documento.iddocumentosPersonal)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-btn
              icon
              color="white"
              class="mr-4"
              @click="download(documento.URL)"
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        align="center"
      >
        <div class="text-subtitle-1 font-weight-bold text--disabled">
          No hay documentos registrados.
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-bold d-inline">
          Actualización de informes de antecedentes
        </div>
        <agregar-documento-dialog-component
          v-if="perfil === 'Antecedentes'"
          :id-personal="personal.idPersonal"
          :antecedentes="true"
          :validacion="false"
        />
      </v-col>
    </v-row>
    <template v-if="perfil !== 'Validación'">
      <v-row v-if="documentosAntecedentes.length > 0">
        <v-col
          v-for="documento in documentosAntecedentes"
          :key="documento.id"
          cols="3"
        >
          <v-card
            color="secondary"
            tile
          >
            <v-card-title class="d-inline-block">
              <div class="text-subtitle-1 font-weight-bold white--text">
                {{ documento.nombre }}
              </div>
              <div class="text-subtitle-2 font-weight-bold white--text">
                {{ documento.TipoDocumento.title }}
              </div>
              <div class="text-body-2 primary--text">
                Archivo cargado el {{ formatDate(documento.fecha) }}
              </div>
            </v-card-title>
            <v-card-text>
              <div class="text-caption primary--text">
                Observaciones
              </div>
              <div
                v-if="documento.observaciones !== ''"
                class="text-body-2 primary--text font-weight-bold"
              >
                {{ documento.observaciones }}
              </div>
              <div
                v-else
                class="text-body-2 primary--text font-weight-bold"
              >
                No hay observaciones
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                icon
                color="white"
                @click="openEliminaDocumentoDialog(documento.iddocumentosPersonal)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <v-btn
                icon
                color="white"
                class="mr-4"
                @click="download(documento.URL)"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row>
        <v-col>
          <v-alert
            border="left"
            color="secondary"
            class="white--text"
          >
            No tiene permisos para ver esta información.
          </v-alert>
        </v-col>
      </v-row>
    </template>
    <v-row>
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-bold d-inline">
          Informes de validación
        </div>
        <agregar-documento-dialog-component
          v-if="perfil === 'Validación'"
          :id-personal="personal.idPersonal"
          :antecedentes="false"
          :validacion="true"
        />
      </v-col>
    </v-row>
    <template v-if="perfil !== 'Antecedentes'">
      <v-row v-if="documentosValidacion.length > 0">
        <v-col
          v-for="documento in documentosValidacion"
          :key="documento.id"
          cols="3"
        >
          <v-card
            color="secondary"
            tile
          >
            <v-card-title class="d-inline-block">
              <div class="text-subtitle-1 font-weight-bold white--text">
                {{ documento.nombre }}
              </div>
              <div class="text-subtitle-2 font-weight-bold white--text">
                {{ documento.TipoDocumento.title }}
              </div>
              <div class="text-body-2 primary--text">
                Archivo cargado el {{ formatDate(documento.fecha) }}
              </div>
            </v-card-title>
            <v-card-text>
              <div class="text-caption primary--text">
                Observaciones
              </div>
              <div
                v-if="documento.observaciones !== ''"
                class="text-body-2 primary--text font-weight-bold"
              >
                {{ documento.observaciones }}
              </div>
              <div
                v-else
                class="text-body-2 primary--text font-weight-bold"
              >
                No hay observaciones
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                icon
                color="white"
                @click="openEliminaDocumentoDialog(documento.iddocumentosPersonal)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <v-btn
                icon
                color="white"
                class="mr-4"
                @click="download(documento.URL)"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row>
        <v-col>
          <v-alert
            border="left"
            color="secondary"
            class="white--text"
          >
            No tiene permisos para ver esta información.
          </v-alert>
        </v-col>
      </v-row>
    </template>
    <elimina-documento-dialog-component
      :active="eliminaDocumentoDialog"
      :id-personal="selectedPersonal"
      :id-documento="selectedDocumento"
      @close="eliminaDocumentoDialog = false"
    />
  </v-container>
</template>
<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import AgregarDocumentoDialogComponent from './AgregarDocumentoDialogComponent.vue';
import EliminaDocumentoDialogComponent from './EliminaDocumentoDialogComponent.vue';

export default {
  components: {
    AgregarDocumentoDialogComponent,
    EliminaDocumentoDialogComponent,
  },

  props: {
    personal: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      selectedPersonal: null,
      selectedDocumento: null,
      eliminaDocumentoDialog: false,
      documentosPersonal: [],
    };
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    ...mapGetters('documento', {
      documentos: 'getDocumentos',
    }),

    filteredDocumentos() {
      return this.documentos.filter(
        (doc) => doc.fk_idTipoDocumento !== 66
        && doc.fk_idTipoDocumento !== 67 && doc.fk_idEstatus === 1
        ,
      );
    },

    documentosAntecedentes() {
      return this.documentos.filter(
        (doc) => doc.fk_idTipoDocumento === 66 && doc.fk_idEstatus === 1,
      );
    },

    documentosValidacion() {
      return this.documentos.filter(
        (doc) => doc.fk_idTipoDocumento === 67 && doc.fk_idEstatus === 1,
      );
    },
  },

  async mounted() {
    this.documentosPersonal = await this.fetchDocumentosPersonal(Number(this.personal.cib));
  },

  methods: {
    ...mapActions('documento', ['fetchDocumentosPersonal']),

    formatDate(fecha) {
      return moment(fecha).format('DD/MM/YYYY');
    },

    openEliminaDocumentoDialog(selectedDocumento) {
      this.selectedDocumento = selectedDocumento;
      this.selectedPersonal = this.personal.idPersonal;
      this.eliminaDocumentoDialog = true;
    },
  },
};
</script>
